export default function useFormValidation(){

  const requiredWarning = "Este campo é de preenchimento obrigatório";

  const validateForm = (currentForm) => {
    let validForm = true;
    Object.keys(currentForm).forEach( key => {
      const { required, value } = currentForm[key];
      if(required && value == null){
        const hasError = currentForm[key].errors.findIndex(error => error == requiredWarning) > -1
        if(!hasError){
          currentForm[key].errors.push(requiredWarning);  
        }
        validForm = false;
      }
    });
    return validForm;
  }

  const validateField = (currentForm,value,key) => {
    const { required } = currentForm[key];
    currentForm[key].errors = [];
    if(required && value == null){
      currentForm[key].errors.push(requiredWarning)  
    }
  }

  return {
    validateForm,
    validateField
  }
}

